export function useActiveProductSeoMeta() {
  const { activeProduct, activeVariant } = storeToRefs(useProductVariantsStore())

  const { data } = useEcommerceCatalogue()

  const image = computed(() => {
    const ean = getEan(activeVariant) || getEan(activeProduct.value?.variants?.find(it => !!it.ean))
    if (!ean) {
      return undefined
    }

    return data.value?.get(ean)?.firstImage
  })

  useSeoMeta({
    ogImage: () => image.value?.url,
    ogImageAlt: () => image.value?.altText,
  })
}
